import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import {
  dashboardProps,
  syncUsersByCRMProps,
} from "src/interfaces/dashboard.interfaces";

const initialState: dashboardProps = {
  totalQueries: {
    WalkIn: 0,
    Phone: 0,
    Website: 0,
  },
  queriesByStatus: 0,
  transactions: "$0",
  openfollowup: 0,
  actionablequery: [],
  queries: [],
};

const syncUsersByCRMInitialState: syncUsersByCRMProps = {
  loading: false,
  error: null,
  data: {
    status: null,
    message: null,
    result: {
      count: 0,
      users: [],
    },
  },
};

export const dashboardsSlice = createSlice({
  name: "dashboards",
  initialState,
  reducers: {
    setDashboards: (state, action: PayloadAction<dashboardProps>) => {
      return action.payload;
    },
    removeDashboards: () => {
      return initialState;
    },
  },
});

const syncUsersByCRMSlice = createSlice({
  name: "syncUsersByCRM",
  initialState: syncUsersByCRMInitialState,
  reducers: {
    fetchSyncUsersByCRMRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSyncUsersByCRMSuccess: (
      state,
      action: PayloadAction<syncUsersByCRMProps["data"]>
    ) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload;
    },
    fetchSyncUsersByCRMFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setDashboards, removeDashboards } = dashboardsSlice.actions;
export const {
  fetchSyncUsersByCRMRequest,
  fetchSyncUsersByCRMFailure,
  fetchSyncUsersByCRMSuccess,
} = syncUsersByCRMSlice.actions;

export const selectDashboards = (state: RootState) => {
  return state.dashboards;
};
export default {
  dashboards: dashboardsSlice.reducer,
  syncUsersByCRM: syncUsersByCRMSlice.reducer,
};
